import styled from 'styled-components';

import {colors, font} from 'theme';

export const Root = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
    width: 100%;
    height: 100%;
`;

export const ModalText = styled.div`
    font-family: ${font.family.primary};
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    color: ${colors.textPrimary};
`;

export const ButtonWrapper = styled.div`
    display: flex;
    flex-direction: row;
    gap: 10px;
    width: 100%;
    height: 100%;
`;
